import React, { useRef } from 'react';
import LazyContext from '../../../LazyLoadingImage/LazyContext';
import { LAZYLOAD_ROW_START } from '../../../types';
import { useRowVisibility } from '../hooks/useRowVisibility';
import TorpedoContentStrip from './ContentStrip';
import HiddenRow from './HiddenRow';
import ItemRow from './ItemRow';
import OffsetTracking from './OffsetTracking';
import TorpedoItemElement from './TorpedoItem';
const TorpedoRow = ({ idx , width , height , layoutItems , dataItems , contentStrip , scrollOptims , onOffsetReached , renderItem , rowAlign  })=>{
    const ref = useRef(null);
    const isVisible = useRowVisibility(ref, {
        enabled: scrollOptims
    });
    return /*#__PURE__*/ React.createElement(LazyContext.Provider, {
        value: idx >= LAZYLOAD_ROW_START
    }, /*#__PURE__*/ React.createElement(OffsetTracking, {
        rowIdx: idx,
        onOffsetReached: onOffsetReached
    }, /*#__PURE__*/ React.createElement("div", {
        ref: ref
    }, isVisible ? /*#__PURE__*/ React.createElement(ItemRow, {
        rowAlign: rowAlign,
        rowIdx: idx,
        width: width,
        height: height,
        scrollOptims: scrollOptims
    }, layoutItems.map((layoutItem)=>/*#__PURE__*/ React.createElement(TorpedoItemElement, {
            key: `item-${layoutItem.idx}`,
            layoutItem: layoutItem,
            dataItem: dataItems[layoutItem.dto.id],
            renderItem: renderItem
        }))) : /*#__PURE__*/ React.createElement(HiddenRow, {
        items: layoutItems,
        width: width,
        height: height
    }), contentStrip && /*#__PURE__*/ React.createElement(TorpedoContentStrip, {
        width: width
    }, contentStrip))));
};
TorpedoRow.displayName = 'TorpedoRow';
export default TorpedoRow;
